import { CSSProperties, useEffect, useState } from 'react';
import { ymGoal } from '../../../components/common';
import { useMounted } from '../../../hooks/useMounted';
import CabelmanSquare2 from '../../../img/Telesputnik_652x367_2.gif';
import Cabelman from '../../../img/Баннер_2.gif';
import Cabelman2 from '../../../img/Сabelman-934x114.gif';

export function useMediaQuery(query: string) {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia(query);
        setMatches(mediaQuery.matches);

        const handler = (event: MediaQueryListEvent) => setMatches(event.matches);
        mediaQuery.addEventListener('change', handler);

        return () => mediaQuery.removeEventListener('change', handler);
    }, [query]);

    return matches;
}

interface TemporalBannerProps {
    sectionStyle?: CSSProperties,
    imgStyle?: CSSProperties,
}

function TemporalBanner({ sectionStyle, imgStyle }: TemporalBannerProps) {
    const isMobile = useMediaQuery('(max-width: 600px)');
    const mounted = useMounted();

    const erid = '2W5zFJhEkX3';

    useEffect(() => {
        if (mounted) {
            ymGoal('banner_videostream_april_2026_view');
        }
    }, [mounted]);

    return (
        <section className="welcome-news" style={{ textAlign: 'center', ...sectionStyle }}>
            {isMobile ?
                <a href={`https://i.moscow/event/e93003a1e50e4392a862ee30242f285e?erid=${erid}`} target="_blank">
                    <img src={Cabelman} alt="Cabelman" style={{ borderRadius: '14px', ...imgStyle, width: '100%' }} />
                </a>
                :
                <a href={`https://i.moscow/event/e93003a1e50e4392a862ee30242f285e?erid=${erid}`} target="_blank">
                    <img src={Cabelman} alt="Cabelman" style={{ borderRadius: '14px', ...imgStyle }} />
                </a>
            }
        </section>
    );
}

export function TemporalBanner2({ sectionStyle, imgStyle }: TemporalBannerProps) {
    const isMobile = useMediaQuery('(max-width: 600px)');
    const mounted = useMounted();

    // const erid = '';

    useEffect(() => {
        if (mounted) {
            ymGoal('banner_mdlg_footer_view');
        }
    }, [mounted]);

    return (
        <section className="welcome-news" style={{ textAlign: 'center', ...sectionStyle }}>
            {isMobile ?
                <a href={'https://www.msk-ix.ru/medialogistika/'} target="_blank">
                    <img src={CabelmanSquare2} alt="Cabelman" style={{ borderRadius: '14px', ...imgStyle, width: '100%' }} />
                </a>
                :
                <a href={'https://www.msk-ix.ru/medialogistika/'} target="_blank">
                    <img src={Cabelman2} alt="Cabelman" style={{ borderRadius: '14px', ...imgStyle }} />
                </a>
            }
        </section>
    );
}

export default TemporalBanner;